/**
 * @generated SignedSource<<9cfcbad95c2a85b19018e21c4b74799c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksUseCurrentArticlePrebidConfigArticle$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly name: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "hooksUseCurrentArticlePrebidConfigArticle";
};
export type hooksUseCurrentArticlePrebidConfigArticle$key = {
  readonly " $data"?: hooksUseCurrentArticlePrebidConfigArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseCurrentArticlePrebidConfigArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksUseCurrentArticlePrebidConfigArticle"
};

(node as any).hash = "f471cb0318f78c2e6b1fe4ddd8f72bc8";

export default node;
